import Parallax from 'parallax-js/dist/parallax'

export default () => {
    let parallaxes = document.querySelectorAll('.parallax')
    if (parallaxes) {
        parallaxes.forEach(function(parallax) {
            let newParallax = new Parallax(parallax, {
                hoverOnly: false
            })
        })
    }
}
